<div class="w-p-100 flex flex-row justify-start items-center">
  <div class="task-breadcrumb flex flex-row justify-start items-center">
    <a class="pointer" *ngIf="isSupportMember" [matTooltip]="'Home'" (click)="onHomeClicked()" data-copilot="task-toolbar-btn-home">
      <span class="m-r-6">
        <i class="fa fa-home"></i>
      </span>
    </a>
    <a class="pointer"
       *ngIf="card.parentTicket"
       [matTooltip]="card.parentTicket.displayTitle"
       (click)="openParentTask(card.parentTicket)"
       data-copilot="task-toolbar-btn-parent-task">
      <span>{{parentLabel}}</span>
    </a>
    <span class="m-r-6" *ngIf="card.parentTicket">/</span>
    <span [matTooltip]="card.name"><i class="far fa-check"></i>{{taskLabel}}</span>
    <div class="generated-by-xatbot" *ngIf="isGeneratedByXatBot && isSupportMember">
      <i class="fa-solid fa-sparkles"></i>
      <span>Generated by XatBot</span>
    </div>
  </div>
  <ul class="header-actions-icon m-l-auto">
    <li matTooltip="Previous" *ngIf="data.input.toolbarSubTaskNavigation"
        [ngClass]="{'disabled': data.input.toolbarSubTaskNavigation.pageNo <= 0}" matTooltip="Previous subtask"><a
      class="pointer" data-copilot="task-toolbar-btn-prev-subtask" (click)="openSubtask(data.input.toolbarSubTaskNavigation.pageNo - 1)"><i
      class="far fa-chevron-left"></i></a></li>
    <li matTooltip="Next" *ngIf="data.input.toolbarSubTaskNavigation"
        [ngClass]="{'disabled': data.input.toolbarSubTaskNavigation.pageNo+1>=data.input.toolbarSubTaskNavigation.pageCount}"
        matTooltip="Next subtask"><a class="pointer"
                                     data-copilot="task-toolbar-btn-next-subtask"
                                     (click)="openSubtask(data.input.toolbarSubTaskNavigation.pageNo + 1)"><i
      class="far fa-chevron-right"></i></a></li>
    <li class="hide"><a class="pointer" [matMenuTriggerFor]="menu"><i class="far fa-ellipsis-h"></i></a></li>
    <mat-menu class="activity-menu" #menu="matMenu">
      <button mat-menu-item>
        <i class="fas fa-envelope" aria-hidden="true"></i>
        <span>Mail</span>
      </button>
      <button mat-menu-item>
        <i class="fas fa-facebook" aria-hidden="true"></i>
        <span>Facebook</span>
      </button>
      <button mat-menu-item>
        <i class="fas fa-linkedin" aria-hidden="true"></i>
        <span>Linkedin</span>
      </button>
      <button mat-menu-item>
        <i class="fas fa-twitter" aria-hidden="true"></i>
        <span>Twitter</span>
      </button>
    </mat-menu>
    <li *ngIf="!isSupportMember" matTooltip="Close"><a data-cy="task-toolbar-close" class="pointer" (click)="onClosedClicked()" style="font-weight: 400"> <i
      class="far fa-times"></i></a></li>
  </ul>
</div>
